import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { NavL2 } from '@mesh.ai/rabbit';
import { useIsStaticRouteWithSidebar } from 'Deer/hooks/useIsStaticRouteWithSidebar';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { setL2Visible, useSelectIsL2Visible } from 'Deer/slice/DeerNav.slice';
import { useDispatch } from 'react-redux';

import { CompanySecondaryNav } from './Company/CompanySecondaryNav';
import { MyDataSecondaryNav } from './MyDataSecondaryNav';
import { MyTeamSecondaryNav } from './MyTeam/MyTeamSecondaryNav';

const SecondaryNav = () => {
  const { l1Module, l2Module } = useRouteToNavLevels();
  const isMyData = l1Module === 'myData';
  const isTeam = l1Module === 'team';
  const isCompany = l1Module === 'company';
  const dispatch = useDispatch();

  const isL2Visible = useSelectIsL2Visible();
  const isStaticRouteWithSidebar = useIsStaticRouteWithSidebar();
  const setL2VisibleHandler = () => {
    dispatch(
      setL2Visible({
        isL2Visible: !isL2Visible,
      })
    );
  };

  // for the first mount only, such as in case of page refresh
  useEffect(() => {
    if (l2Module || isStaticRouteWithSidebar) {
      dispatch(
        setL2Visible({
          isL2Visible: true,
        })
      );
    }
  }, []);

  return (
    <Box style={{ zIndex: 10 }}>
      <NavL2 open={isL2Visible} onToggle={setL2VisibleHandler}>
        {isMyData ? <MyDataSecondaryNav /> : null}
        {isTeam ? <MyTeamSecondaryNav /> : null}
        {isCompany ? <CompanySecondaryNav /> : null}
      </NavL2>
    </Box>
  );
};

SecondaryNav.propTypes = {};

export default SecondaryNav;
